'use client';

import { styled, Tooltip, type TooltipProps, tooltipClasses } from '@mui/material';

const PreviewTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    color: theme.palette.text.primary,
    maxWidth: 'none',
  },
}));

export default PreviewTooltip;
